var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-col items-center gap-4 text-12 border th-border"},[_c('WFTranslate',{attrs:{"k":"offer-qr"}}),_c('img',{staticClass:"w-80",attrs:{"src":_vm.qr}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }